import React from "react";
import { Label, PrintHeaderContainer } from "./PrintHeaderInfoStyle";

interface PrintHeaderInfoProps {
  pharmacyName: string;
  createdAt?: string;
}

const PrintHeaderInfo: React.FC<PrintHeaderInfoProps> = ({
  pharmacyName,
  createdAt,
}) => {
  return (
    <PrintHeaderContainer className="print-header">
      <span>
        <Label>Pharmacy Name: </Label> {pharmacyName}
      </span>
      {createdAt && (
        <span>
          <Label>Date: </Label> {createdAt}
        </span>
      )}
    </PrintHeaderContainer>
  );
};

export default PrintHeaderInfo;
